import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import 'firebase/database';
import FontAwesome from 'react-fontawesome';
import {Editor} from '../editor-components';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import EditGiftCardDialog from './edit-gift-card-dialog';
import CreateGiftCardDialog from './create-gift-card-dialog';

/** @class GiftCardList
  * A component for displaying and editing affiliate groups.
  * @prop {Object} match - the parameters from ReactRouter
  */
export default class GiftCardList extends ReactFireComponent {
  /** @constructor
    * Constructs a new ActiveUserList.
    */
  constructor(props) {
    super(props);
    this.dataURL = `${props.dataURL}/giftCards`;
    this.state = {
      giftCards: [],
      exhibitors: [],
      selectedGiftCard: null,
      showNewDialog: false
    }
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.toggleNewDialog = this.toggleNewDialog.bind(this);
  }
  /** @method componentWillMount
    * Binds the component to the active gift
    * card list in the firebase database.
    */
  componentWillMount(){
    this.bindAsArray(this.dataURL, 'giftCards');
    this.bindAsArray('/exhibitors', 'exhibitors');
  }
  /** @method componentWillUnmount
    * Unbinds the component from the active gift
    * card list in the firebase database.
    */
  componentWillUnmount() {
    this.unbind('giftCards');
    this.unbind('exhibitors');
  }
  /** @method handleSelect
    * Handles the selection of a gift card
    * for editing.
    */
  handleSelect(id) {
    this.setState({
      selectedGiftCard: id
    });
  }
  /** @method handleEdit
    * Allows the selection of a gift card from the list to edit.
    * @param {string} id - the identity of the gift card to edit
    */
  handleEdit(id) {
    this.setState({
      selectedGiftCard: id
    });
  }
  /** @method handleRemove
    * Allows the removal of an affiliate from the list.
    * @param {string} id - the identifier of the affiliate
    */
  handleRemove(id) {
    if(window.confirm("Are you sure?  This will permanently remove them from the Vexpo Admin Platform.")) {
      firebase.database().ref(`${this.dataURL}/${id}`).set(null);
    }
  }
  /** @method toggleNewDialog
    * Displays or hides the new affiliate dialog
    */
  toggleNewDialog() {
    this.setState({showNewDialog: !this.state.showNewDialog});
  }
  /** @method render
    * Renders the component
    */
  render() {
    const columns = [
      {Header: 'Exhibitor', accessor: 'exhibitor'},
      {Header: 'Image', accessor: 'image', Cell: (row) => (
        <img src={row.value} alt="gift card image" style={{height: '100px'}}/>
      )},
      {Header: 'Deal', accessor: 'deal'},
      {Header: 'Code', accessor: 'code'},
      {Header: '', accessor: 'id', Cell: (row) => (
        <span>
          <FontAwesome name="edit"
            style={{color: 'orange', cursor: 'pointer'}}
            onClick={()=>{this.handleEdit(row.value)}}
            />
          <FontAwesome name="times"
            style={{color: "red", cursor: "pointer"}}
            onClick={()=>{this.handleRemove(row.value)}}
            />
        </span>
      )}
    ]
    const selectedGiftCard = this.state.giftCards.find(giftCard => {
      return giftCard.id === this.state.selectedGiftCard;
    });
    const editorDialog = selectedGiftCard
      ? <EditGiftCardDialog
          exhibitors={this.state.exhibitors}
          dataURL={this.dataURL}
          giftCard={selectedGiftCard}
          show={true}
          onExit={()=>{this.setState({selectedGiftCard: null})}} />
      : '';
    const style = {
      width: '100%'
    }
    return (
      <Editor>
        <button className="btn btn-success" onClick={this.toggleNewDialog}>
          <FontAwesome name="plus"/>
          Add New Gift Card
        </button>
        <CreateGiftCardDialog
          exhibitors={this.state.exhibitors}
          dataURL={this.dataURL}
          show={this.state.showNewDialog}
          onExit={this.toggleNewDialog}
          />
        {editorDialog}
        <ReactTable
          className="-striped"
          data={this.state.giftCards}
          columns={columns}
          defaultPageSize={4}
          style={style}
          filterable
          />
      </Editor>
    )
  }
}

GiftCardList.propTypes = {
  dataURL: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/gift-card-editor/gift-card-list.js